<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      // {
      //     key: "request_types",
      //     title: "Вид запроса",
      //   },
      //   {
      //     key: "message",
      //     title: "Вид подзапроса",
      //   },
      //   {
      //     key: "phone",
      //     title: "Номер покупателя",
      //   },
      //   {
      //     key: "limit",
      //     title: "Полученный лимит",
      //   },
      //   {
      //     key: "pay",
      //     title: "Сумма запроса на покупку",
      //   },
      //   {
      //     key: "created_at",
      //     title: "Дата",
      //     dateTimeFormat: true,
      //   },

      exportFields: {
        "Вид запроса": "request_types",
        "Вид подзапроса": "message",
        "Номер покупателя": "phone",
        "Полученный лимит": "limit",
        "Сумма запроса на покупку": "pay",
        "Дата запроса": "created_at",
      },
      staticFilters: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [],
      params: {
        per_page: 2,
      },
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "report/paymart",
      setLink: "report/paymart",
      columns: [
        {
          key: "request_types",
          title: "Вид запроса",
        },
        {
          key: "message",
          title: "Вид подзапроса",
        },
        {
          key: "phone",
          title: "Номер покупателя",
        },
        {
          key: "limit",
          title: "Полученный лимит",
        },
        {
          key: "pay",
          title: "Сумма запроса на покупку",
        },
        {
          key: "created_at",
          title: "Дата",
          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
